import { IInvoiceInformation } from '@epi-models/shared';

import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface UserCompany {
  sizeId?: number | string;
  address?: any;
  invoiceInformation?: IInvoiceInformation;
  hasSignatory?: boolean;
  [key: string]: any;
}

interface CompaniesState {
  userCompany: UserCompany;
  isLoading: boolean;
  isLoaded: boolean;
  isProcessingUpdate: boolean;
  isError?: boolean;
  noPersistance: boolean;
}

export const getInitialState = (): CompaniesState => ({
  userCompany: {},
  isLoading: false,
  isLoaded: false,
  isProcessingUpdate: false,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.LOAD_USER_COMPANY}_REQUEST`]:
    (): Partial<CompaniesState> => ({
      isLoading: true,
      isLoaded: false
    }),

  [`${ApiConstants.LOAD_USER_COMPANY}_SUCCESS`]: (
    state: CompaniesState,
    {
      userCompany: { size, ...rest }
    }: { userCompany: { size: number | string; [key: string]: any } }
  ): Partial<CompaniesState> => ({
    userCompany: { ...rest, sizeId: size },
    isLoading: false,
    isLoaded: true
  }),

  [`${ApiConstants.LOAD_USER_COMPANY}_FAILURE`]:
    (): Partial<CompaniesState> => ({
      isLoading: false,
      isError: true
    }),

  [`${ApiConstants.UPDATE_USER_COMPANY}_REQUEST`]:
    (): Partial<CompaniesState> => ({
      isProcessingUpdate: true
    }),

  [`${ApiConstants.UPDATE_USER_COMPANY}_SUCCESS`]: (
    state: CompaniesState,
    {
      address,
      sizeId,
      invoiceInformation
    }: {
      address: any;
      sizeId: number | string;
      invoiceInformation: IInvoiceInformation;
    }
  ): Partial<CompaniesState> => ({
    userCompany: {
      ...state.userCompany,
      address,
      sizeId,
      invoiceInformation
    },
    isProcessingUpdate: false
  }),

  [`${ApiConstants.UPDATE_USER_COMPANY}_FAILURE`]:
    (): Partial<CompaniesState> => ({
      isProcessingUpdate: false
    }),

  [`${ApiConstants.LOGOUT_ACTION}_SUCCESS`]: (): Partial<CompaniesState> => ({
    isLoading: false,
    isLoaded: false,
    userCompany: {}
  }),

  [`${ApiConstants.LOAD_COMPANY_HAS_SIGNATORY}_SUCCESS`]: (
    state: CompaniesState,
    { hasSignatory }: { hasSignatory: boolean }
  ): Partial<CompaniesState> => ({
    userCompany: { ...state.userCompany, hasSignatory }
  })
});
